import { EVENTS } from "./types/events";

import makeEvent from "./makeEvent";
import { FormSubmitted } from "./types/redventures.usertracking.v3.FormSubmitted";
import { FieldSelected } from "./types/redventures.usertracking.v3.FieldSelected";
import { FieldInputted } from "./types/redventures.usertracking.v3.FieldInputted";

type FormEvents = FormSubmitted & FieldSelected & FieldInputted;

type UseFormEvents = (data: FormEvents) => {
  fieldInputted: (overrideProps?: Partial<FieldInputted>) => void;
  fieldSelected: (overrideProps?: Partial<FieldSelected>) => void;
  formSubmitted: (overrideProps?: Partial<FormSubmitted>) => void;
};

const useFormEvents: UseFormEvents = (data) => {
  const formEvent = makeEvent<FormEvents, EVENTS>(data);
  return {
    fieldInputted: formEvent<FieldInputted>(EVENTS.FieldInputted),
    fieldSelected: formEvent<FieldSelected>(EVENTS.FieldSelected),
    formSubmitted: formEvent<FormSubmitted>(EVENTS.FormSubmitted),
  };
};

export default useFormEvents;
